import { PostGoalData } from "../goals";
import request from "./internal-base-request";

export const applyBulkGoalArchiveInternalApi = async (selectionObjectID: string, archiveObject: any) => {
	const [data] = await request<{ result: any; errors: string[]; warnings: string[] }>(
		`/v1/goals/bulk/selection/${selectionObjectID}/update`,
		{
			method: "POST",
			body: JSON.stringify({
				service: "goal",
				updates: {
					status: "archived",
					...archiveObject,
				},
			}),
		}
	);

	if (data.errors?.length > 0) {
		throw new Error(data.errors.join(", "));
	}

	return data.result;
};

export const createGoalsInternalApi = async (data: PostGoalData) => {
	const [goalData] = await request<any>("/v1/goals", {
		method: "POST",
		body: JSON.stringify({ ...data }),
	});

	return goalData;
};
